import { GridColDef, GridPreProcessEditCellProps } from '@mui/x-data-grid';
import { DURATION_SECONDS } from '../../../constants';
import { ALIGNMENT, Burst, BurstSlice, TYPE } from './types';
import { SplitWeekCell } from '../../../components/SplitWeek';

const columns: GridColDef[] = [
  {
    field: 'split',
    headerName: 'Split',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    sortable: false,
    editable: false,
    maxWidth: 10,
    renderCell: SplitWeekCell
  },
  {
    field: 'active',
    headerName: 'Active',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.BOOLEAN,
    flex: 1,
    maxWidth: 80,
    sortable: false,
    editable: true
  },
  {
    field: 'weekCommencing',
    headerName: 'W/C',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.STRING,
    flex: 1,
    sortable: false,
    editable: false
  },
  {
    field: 'cpt',
    headerName: 'CPT',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.NUMBER,
    sortable: false,
    flex: 1,
    editable: false,
    valueFormatter: (params: { value: number }) => {
      return params.value.toFixed(2);
    }
  },
  {
    field: 'cpm',
    headerName: 'CPM',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.NUMBER,
    sortable: false,
    editable: false,
    valueFormatter: (params: { value: number }) => {
      return params.value.toFixed(2);
    }
  },
  {
    field: 'tarps',
    headerName: 'TARPs',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.NUMBER,
    sortable: false,
    editable: false,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const hasError = params.props.value < 0;
      return { ...params.props, error: hasError };
    },
    valueFormatter: (params: { value: number }) => {
      return params.value.toFixed(2);
    }
  },
  {
    field: 'budget',
    headerName: 'Budget',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.NUMBER,
    sortable: false,
    editable: false,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const hasError = params.props.value < 0;
      return { ...params.props, error: hasError };
    },
    valueFormatter: (params: { value: number }) => {
      return params.value.toFixed(2);
    }
  },
  {
    field: 'impact',
    headerName: '000s',
    headerAlign: ALIGNMENT.CENTER,
    align: ALIGNMENT.CENTER,
    type: TYPE.NUMBER,
    sortable: false,
    editable: false,
    preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
      const hasError = params.props.value < 0;
      return { ...params.props, error: hasError };
    },
    valueFormatter: (params: { value: number }) => {
      return params.value.toFixed(2);
    }
  }
];

const initialBurst: Burst = {
  budget: 0,
  calculatedTotalBudget: 0,
  calculatedTotalTarps: 0,
  calculatedTotalImpact: 0,
  tarps: 0,
  impact: 0,
  rows: []
};

const initialState: BurstSlice = {
  columns: columns,
  [DURATION_SECONDS.FIVE]: initialBurst,
  [DURATION_SECONDS.TEN]: initialBurst,
  [DURATION_SECONDS.FIFTEEN]: initialBurst,
  [DURATION_SECONDS.THIRTY]: initialBurst,
  [DURATION_SECONDS.FORTY_FIVE]: initialBurst,
  [DURATION_SECONDS.SIXTY]: initialBurst,
  [DURATION_SECONDS.NINETY]: initialBurst
};

export default initialState;
